import {
    useConfirmRequestedValidationPhoneMutation,
    useCurrentCustomerLazyQuery,
    useLoginWithPhoneAndOtpMutation,
    useRegisterNewAccountByOtpMutation,
    useRequestValidatePhoneMutation,
    type Location,
    useSupportMenuItemsQuery,
} from '../../types/front.graphql';

export const useRequestValidatePhone = () => {
    const [requestValidatePhone, { loading, error }] = useRequestValidatePhoneMutation();

    return {
        requestValidatePhone,
        loading,
        error,
    };
};

export const useLoginWithPhoneAndOtp = () => {
    const [loginWithPhoneAndOtp, { loading, error }] = useLoginWithPhoneAndOtpMutation();

    return {
        loginWithPhoneAndOtp,
        loading,
        error,
    };
};

export const useConfirmRequestedValidationPhone = () => {
    const [confirmRequestedValidationPhone, { data, loading, error }] = useConfirmRequestedValidationPhoneMutation();

    return {
        confirmRequestedValidationPhone,
        loading,
        error,
        data,
    };
};

export const useRegisterNewAccountByOtp = () => {
    const [registerNewAccountByOtp, { data, loading, error }] = useRegisterNewAccountByOtpMutation();

    return {
        registerNewAccountByOtp,
        loading,
        error,
        data,
    };
};

/**
 * NOTE:
 * Hook này đã được import đúng từ module-customer (public API).
 * Tuy nhiên, hiện tại các module trong monorepo vẫn đang import chéo nhau
 * thông qua các file build trong `dist/`, khiến TypeScript suy luận type
 * phụ thuộc vào internal path và gây lỗi:
 *
 * "The inferred type cannot be named without a reference to dist/types"
 *
 * Để tránh việc leak internal types và unblock build,
 * tạm thời sử dụng implementation tự define bên dưới.
 * Khi các module được refactor để import qua entry point chuẩn
 * (không dùng dist), đoạn code này sẽ được thay thế lại bằng hook gốc.
 */
export const useGetCurrentCustomer = () => {
    const [getCurrentCustomer, { loading, error }] = useCurrentCustomerLazyQuery();

    return {
        getCurrentCustomer,
        loading,
        error,
    };
};

// NOTE: This API from app generating on module-theme
export const useFetchSupportMenuItems = (location: Location) => {
    const { data, error, refetch, loading } = useSupportMenuItemsQuery({
        variables: {
            location,
        },
    });

    const supportMenuItems = data?.supportMenuItems;

    return {
        supportMenuItems,
        loading,
        error,
        refetch,
    };
};
